module.exports = __webpack_public_path__ + "img/personaltrainer.a0b1e433.png";